<template>
  <div>
    <page-header
      icon="mdi-finance"
      title="Finansije i izveštaji"
      subtitle="Transakcije, provizije, fakture, isplate i promet restorana"
    />

    <gps-account-connect v-if="!gpsConnected" @connected="gpsConnected = true" />

    <template v-else>
      <v-tabs v-model="tab" show-arrows background-color="primary" dark>
        <v-tab v-for="item in items" :key="item.value" :value="item.value">
          <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" :touchless="true">
        <v-tab-item v-for="item in items" :key="item.value">
          <div class="px-4 pt-2">
            <component :is="item.component" v-if="tab === item.value" />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import PageHeader from "@/components/global/PageHeader.vue";
import GpsAccountConnect from "@/components/restaurant/finance/GpsAccountConnect.vue";
import { hasGpsToken } from "@/plugins/gpsApi";
import {
  FinanceTabOverview,
  FinanceTabTurnover,
  FinanceTabTransactions,
  FinanceTabBalanceLedger,
  FinanceTabCommissions,
  FinanceTabInvoices,
  FinanceTabPayouts,
  FinanceTabPlatformPayments,
  FinanceTabPromotions,
  FinanceTabRefunds,
  FinanceTabDeposits,
  FinanceTabRestaurantPayouts,
  FinanceTabExport,
} from "@/components/restaurant/finance";

export default {
  name: "RestaurantFinance",

  components: { PageHeader, GpsAccountConnect },

  data: () => ({
    tab: 0,
    gpsConnected: false,
  }),

  computed: {
    items() {
      return [
        {
          tab: "Pregled",
          icon: "mdi-view-dashboard-outline",
          component: FinanceTabOverview,
          value: 0,
        },
        {
          tab: "Promet",
          icon: "mdi-chart-line",
          component: FinanceTabTurnover,
          value: 1,
        },
        {
          tab: "Transakcije",
          icon: "mdi-swap-horizontal",
          component: FinanceTabTransactions,
          value: 2,
        },
        {
          tab: "Knjiga salda",
          icon: "mdi-book-open-variant",
          component: FinanceTabBalanceLedger,
          value: 3,
        },
        {
          tab: "Provizije",
          icon: "mdi-percent-outline",
          component: FinanceTabCommissions,
          value: 4,
        },
        {
          tab: "Fakture",
          icon: "mdi-file-document-outline",
          component: FinanceTabInvoices,
          value: 5,
        },
        { tab: "Isplate", icon: "mdi-cash-fast", component: FinanceTabPayouts, value: 6 },
        {
          tab: "Plaćanja platformi",
          icon: "mdi-bank-transfer",
          component: FinanceTabPlatformPayments,
          value: 7,
        },
        {
          tab: "Promocije",
          icon: "mdi-tag-heart-outline",
          component: FinanceTabPromotions,
          value: 8,
        },
        {
          tab: "Refundacije",
          icon: "mdi-cash-refund",
          component: FinanceTabRefunds,
          value: 9,
        },
        {
          tab: "Uplate restorana",
          icon: "mdi-cash-plus",
          component: FinanceTabDeposits,
          value: 10,
        },
        {
          tab: "Isplate restoranu",
          icon: "mdi-cash-minus",
          component: FinanceTabRestaurantPayouts,
          value: 11,
        },
        { tab: "Izvoz", icon: "mdi-export", component: FinanceTabExport, value: 12 },
      ];
    },
  },

  created() {
    this.gpsConnected = hasGpsToken();
  },
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
